import type { components } from '@/api/qraft/schema';

export type Language = components['schemas']['Language'];

/**
 * Display names for the backend `Language` enum.
 *
 * Typed as `Record<Language, string>` on purpose: the keys are pinned to the
 * generated `Language` union, so if the backend adds or removes a language and
 * the client is regenerated, this map stops type-checking until it's updated —
 * the labels can't silently drift from the source enum.
 */
export const LANGUAGE_LABELS: Record<Language, string> = {
  EN: 'English',
  ES: 'Spanish',
  FR: 'French',
  PT_BR: 'Portuguese (Brazil)',
};

/** `[code, label]` pairs for building selects/menus. */
export const LANGUAGE_OPTIONS = Object.entries(LANGUAGE_LABELS) as [
  Language,
  string,
][];
